import { defineStore } from "pinia"

export const useStudentWheelStore = defineStore("studentWheelStore", {
  state: () => ({
    modalOpen: false,
  }),

  actions: {
    setModalOpen(isOpen: boolean) {
      this.modalOpen = isOpen
    },
  },
})
